import { withConfig } from "@/utils/withConfig";
import { PaymentMethods } from "./PaymentMethods";
import type { PaymentMethodsProps } from "./PaymentMethodsProps";

export * from "./PaymentMethods";
export * from "./PaymentMethodsProps";

export const PaymentMethodsWithConfig = withConfig<PaymentMethodsProps>(
  PaymentMethods,
  "payment_methods",
);
